<template>
  <div class="mt-10">
    <v-container fluid>
      <v-file-input :disabled="editData" id="fileUpload" accept="image/*" @change="previewImage"
        v-model="companyLogo.data" style="display: none">
      </v-file-input>

      <v-card class="mt-5">
        <v-row class="pa-2 ma-0" align="center">
          <v-col md="4" class="px-4">
            <h2>{{ $t("company_data") }}</h2>
          </v-col>
          <v-col offset="5" md="3" class="px-4">
            <v-btn class="float-right font-weight-medium" style="font-size: 13px; !important" color="primary"
              v-show="editData && notSPV" @click="editData = !editData">EDIT DATA</v-btn>
          </v-col>
        </v-row>

        <v-form ref="form" :class="editData ? 'data-company' : ''" :disabled="editData" v-model="validEdit">
          <v-row class="pa-2 ma-0 mt-n8" align="start" justify="start">
            <v-col md="6">
              <v-col md="12" class="ml-n6">
                <v-row class="pa-2 ma-0" align="center">
                  <v-col md="12" class="ml-n4 mb-n4 mt-4">
                    <div style="
                        width: 120px;
                        text-align: center;
                        font-size: 12px;
                        color: #858585;
                      ">
                      {{ $t("company_logo") }}
                    </div>
                  </v-col>
                  <v-col md="2" xl="1">
                    <div style="
                        width: 120px;
                        height: 120px;
                        border-radius: 8px;
                        border: 1px solid #c4c4c4;
                        overflow: hidden;
                      ">
                      <div v-show="companyLogo.url">
                        <v-img :src="companyLogo.url" aspect-ratio="1" contain></v-img>
                      </div>
                      <div class="flexer" :class="!editData ? 'allow-hover' : ''" v-show="companyLogo.url == null"
                        @click="chooseFiles()">
                        <div>
                          <v-icon class="plus-icon">mdi-plus</v-icon>
                        </div>
                        <div v-show="!fileError">
                          {{ uploadingImage }}
                        </div>
                        <div v-show="fileError" style="
                            color: red;
                            text-align: center;
                            width: 120px;
                            font-size: 12px;
                          " class="pa-1">
                          {{ fileError }}
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col md="1" style="margin-left: 100px" @click="chooseFiles()">
                    <v-btn color="primary" outlined class="font-weight-bold" style="border-width: 2px"
                      v-show="!editData && companyLogo.url">
                      {{ $t("change") }}</v-btn>
                  </v-col>
                  <v-col md="12" class="mb-2 mt-n2">
                    <div style="font-size: 16px; color: #c4c4c4" v-show="!editData">
                      {{ $t("max_file_1mb_image") }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="12" class="mt-n12">
                <v-text-field class="id-company" type="text" disabled flat v-model="form.id" :rules="rules"
                  :label="$t('company_id')"></v-text-field>
              </v-col>
              <v-col md="12" class="mt-n4">
                <v-text-field type="email" @keydown.space.prevent v-model="form.email" :disabled="loadingSave"
                  class="id-company" :label="$t('company_email')" maxlength="50" :rules="emailRules"></v-text-field>
              </v-col>
            </v-col>
            <v-col md="6" class="mt-12">
              <v-col md="12">
                <v-text-field type="text" v-model="form.companyName" class="id-company" :disabled="loadingSave"
                  :rules="rules.concat(spacesRules)" :label="$t('company_name')" maxlength="50">
                </v-text-field>
              </v-col>
              <v-col md="12" class="mt-n4">
                <v-text-field type="text" v-model="form.phone" :disabled="loadingSave" class="id-company"
                  :rules="rules4" :label="$t('company_phone')" maxlength="20">
                </v-text-field>
              </v-col>
              <v-col md="12" class="mt-n4">
                <v-text-field type="tel" :label="$t('cutoff_date')" :disabled="loadingSave" class="id-company"
                  maxlength="2" min="1" max="31" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  v-model="form.cutOffDate" color="primary" :rules="rules.concat(minCut).concat(maxCut)"
                  :onkeyup="imposeMinMax(form.cutOffDate)">
                </v-text-field>
              </v-col>
              <v-col md="12" class="mt-n4">
                <v-textarea rows="2" v-model="form.companyAddress" :disabled="loadingSave" class="id-company"
                  :rules="rules.concat(spacesRules)" :label="$t('company_address')" maxlength="200"></v-textarea>
              </v-col>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="pa-2 ma-0" align="center" v-show="!editData">
          <v-col offset="10" md="1" @click="cancelEdit">
            <v-btn color="default" text class="float-right pa-5">
              <span class="primary--text font-weight-medium">{{
                $t("cancel")
              }}</span></v-btn>
          </v-col>
          <v-col md="1">
            <v-btn :disabled="!validEdit" @click="updateCompany" :loading="loadingSave" color="primary"
              class="float-right pa-5">
              <span class="font-weight-medium">
                {{ $t("save") }}
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-4">
        <v-row class="pa-2 ma-0" align="center">
          <v-col v-if="billingInfo.latest_billing" cols="12">
            <h2>
              Appsensi Status :
              <span class="mr-2" style="color: #3277d5">
                {{ billingInfo.latest_billing.plan }}
              </span>
            </h2>
          </v-col>
          <v-col v-if="billingInfo.latest_billing" cols="6">
            <p style="color: #686868; font-size: 12px; line-height: 16px">
              {{ companyInfo.type }} Period
            </p>
            <p>
              {{ dateMoment(billingInfo.latest_billing.currentPayment) }} -
              {{ dateMoment(billingInfo.latest_billing.nextPayment) }}
              <span class="mr-2" v-if="billingInfo.latest_billing.nextPayment" style="
                  border-radius: 12px;
                  padding: 2px 8px 2px 8px;
                  font-size: 10px;
                " :style="
                  checkDaysLefts(billingInfo.latest_billing.nextPayment) > 7
                    ? 'background-color:  rgba(67, 154, 212, 0.1);'
                    : checkDaysLefts(billingInfo.latest_billing.nextPayment) <= 3
                    ? 'background-color:  rgba(230, 74, 77, 0.1);'
                    : 'background-color:  rgba(247, 147, 33, 0.1);'
                ">
                <span @click="
                    checkDaysLefts(billingInfo.latest_billing.nextPayment) <= 7
                      ? (planEnded = true)
                      : ''
                  " style="font-weight: 600" :style="
                    checkDaysLefts(billingInfo.latest_billing.nextPayment) > 7
                      ? 'color: #4399D4;'
                      : checkDaysLefts(billingInfo.latest_billing.nextPayment) <= 3
                      ? 'color: #E64A4D;'
                      : 'color: #F79421;'
                  ">{{ checkDaysLefts(billingInfo.latest_billing.nextPayment) }} {{ $t('daysLeft') }}</span>
              </span>
            </p>

            <v-btn color="primary" @click="$store.dispatch('toggleChangePlanModal', true)">Update Plan</v-btn>
          </v-col>
          <v-col cols="6">
            <p style="color: #686868; font-size: 12px; line-height: 16px">
              Contact Email (PIC)
            </p>
            <p>{{ checkCompanyInfo(companyInfo.email_pic) }}</p>
            <v-btn color="primary" @click="$store.dispatch('togglePICModal', true)">CHANGE PIC</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog @click:outside="$store.dispatch('togglePICModal', false)" overlay-opacity="0.7" v-model="changePIC"
        max-width="470px">
        <v-card class="pa-6">
          <h3>Change Contact</h3>
          <v-form class="mt-4">
            <v-text-field type="email" @keydown.space.prevent v-model="picEmail" label="Change Contact (PIC)"
              maxlength="50" :rules="emailRules">
            </v-text-field>
          </v-form>
          <v-row align="center" class="justify-center">
            <v-col cols="6" style="display: flex" class="justify-end">
              <v-btn color="primary" outlined @click="$store.dispatch('togglePICModal', false)" style="width: 100px">
                CANCEL</v-btn>
            </v-col>
            <v-col cols="6" style="display: flex" class="justify-start">
              <v-btn @click="updatePicEmail()" color="primary" style="width: 100px">SAVE</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog @click:outside="$store.dispatch('toggleChangePlanModal', false)" overlay-opacity="0.7"
        v-model="updatePlan" max-width="520px">
        <v-card class="pa-6">
          <h3 class="mb-4">Update Plan</h3>
          <p>
            {{ $t('updatePlanForm') }}
            <b>{{ picEmail }}</b> {{ $t('asPIC') }} {{ companyInfo.companyName }}
          </p>
          <p>{{ $t('checkEmailForm') }}</p>
          <hr class="mb-4" style="border: 0.8px solid #e6e6e6" />
          <p>{{ $t('furtherInformation') }}</p>
          <b>support@appsensi.com</b>
          <v-col style="display: flex" class="justify-center mt-4">
            <v-btn color="primary" @click="renewalForm()">{{ $t('understand') }}</v-btn>
          </v-col>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
  import moment from "moment";
  import axios from "axios";
  import ENV from "./../../store/modules/environtment";
  export default {
    data() {
      return {
        loadingSave: false,
        noicon: true,
        editData: true,
        // updatePlan: false,
        fileError: null,
        validEdit: true,
        picEmail: "",
        // changePIC: this.$store.getters.getShowPICModal,
        companyInfo: [],
        // billingInfo: [],
        todayDate: moment().locale(this.$i18n.t("lang")).format("D-M-YYYY"),
        baseUrl: this.$store.state.baseUrl,
        uploadingImage: this.$i18n.t("input_file"),
        companyLogo: {
          data: null,
          url: null,
          path: null,
        },
        form: {
          id: null,
          clientID: null,
          companyName: null,
          companyAddress: null,
          cutOffDate: null,
          email: "",
          phone: "",
          startContract: null,
          endContract: null,
          companyLogo: null,
        },
        rules4: [(v) => !v || /^[+]?[0-9 ]+$/.test(v) || "Phone number only"],
        rules: [(v) => !!v || this.$i18n.t("required")],
        emailRules: [
          (v) => !v || /.+@.+\..+/.test(v) || this.$i18n.t("email_required"),
        ],
        spacesRules: [(v) => (v && !!v.trim()) || "Value cannot be blank"],
        minCut: [(v) => v >= 1 || "Min cut off date is 1"],
        maxCut: [(v) => v <= 31 || "Max cut off date is 31"],
      };
    },
    methods: {
      imposeMinMax(el) {
        if (el != "") {
          if (parseInt(el) < parseInt(1)) {
            this.form.cutoff_date = 1;
          }
          if (parseInt(el) > parseInt(31)) {
            this.form.cutoff_date = 31;
          }
        }
      },
      checkCompanyInfo(companyEmail) {
        if (companyEmail) {
          return companyEmail
        } else {
          'You have No PIC email, please update it.'
        }
      },
      renewalForm() {
        window.open(
          `https://docs.google.com/forms/d/e/1FAIpQLSdvDQLLjSCbahMnELLQVQEsgqfYa3vIjhRIXacivfBo2TY0ew/viewform?usp=sf_link`
        );
      },
      async getCompanies() {
        const result = await this.$store.dispatch(
          "getCompanyDetail",
          this.$store.state.company
        );
        this.form = result;
        if (
          result.companyLogo != "-" &&
          result.companyLogo != null &&
          result.companyLogo != ""
        ) {
          this.companyLogo.url = result.companyLogo;
        }
        // this.form.phone_company = '+68123456789'
      },
      async updateCompany() {
        this.loadingSave = true;
        if (this.form.companyLogo == this.companyLogo.url) {
          delete this.form.companyLogo;
        }
        const result = await this.$store.dispatch(
          "editCompanyDetail",
          this.form,
          this.$store.state.company
        );
        if (result) {
          this.getCompanies();
          this.showMessage("success", "Company Detail Updated");
          this.loadingSave = false;
          this.editData = !this.editData;
        } else {
          this.loadingSave = false;
          this.editData = !this.editData;
        }
      },
      async updatePicEmail() {
        this.loadingSave = true;
        const companyId = this.$store.state.company;
        const result = await this.$store.dispatch(
          "updatePicEmail", {
            companyId,
            email_pic: this.picEmail
          }
        );
        if (result) {
          this.getCompanyInfo()
          this.$store.dispatch('togglePICModal', false)
          this.showMessage("success", "PIC Email Updated");
          this.loadingSave = false;
        } else {
          this.loadingSave = false;
        }
      },
      showMessage(type, msg) {
        this.$store.dispatch("nShowMessage", {
          type,
          msg,
        });
      },
      chooseFiles: function () {
        document.getElementById("fileUpload").click();
      },

      async uploadImage(image) {
        const prefix = ENV.firebase.prefixCompanyLogo;
        const companyId = this.$store.state.company;
        const url = `${this.baseUrl}/download/file_upload_general`;
        const headers = {
          headers: {
            "Content-Type": "multipart/form-data",
            action: "File Upload",
            actionId: 1,
          },
        };
        try {
          const formData = new FormData();
          formData.append("file", image);
          formData.append("path", `${prefix}${companyId}`);

          const result = await axios.post(url, formData, headers);
          if (result) {
            if (result.data.code == 200) return result.data.data;
          }
          return {
            url: null,
          };
        } catch (e) {
          return {
            url: null,
          };
        }
      },

      async previewImage(e) {
        const prefix = ENV.firebase.prefixCompanyLogo;
        const companyId = this.$store.state.company;
        if (
          e &&
          e.size < 1024000 &&
          (e.type == "image/png" || e.type == "image/jpeg")
        ) {
          if (this.companyLogo.data) {
            this.loadingImg = true;
            this.uploadingImage = "Updating...";
            const data = await this.uploadImage(this.companyLogo.data);
            this.loadingImg = false;
            this.companyLogo.url = URL.createObjectURL(this.companyLogo.data);
            this.companyLogo.path = data.fileName;
            this.form.companyLogo = `${prefix}${companyId}/${data.fileName}`;
          } else {
            this.companyLogo.url = null;
          }
        } else if (e.size > 1024000) {
          this.companyLogo.url = null;
          this.form.companyLogo = null;
          this.fileError = this.$i18n.t("file_too_big");
        } else if (e.type != "image/png" || e.type != "image/jpeg") {
          this.form.companyLogo = null;
          this.companyLogo.url = null;
          this.fileError = this.$i18n.t("png_or_jpg");
        }
      },
      cancelEdit() {
        this.getCompanies();
        if (this.form.companyLogo == null) {
          this.companyLogo.url = null;
          this.companyLogo.data = null;
          this.fileError = null;
          this.uploadingImage = this.$i18n.t("input_file");
        } else {
          this.companyLogo.url = null;
          this.companyLogo.data = null;
        }
        this.editData = !this.editData;
      },
      checkDaysLefts(date) {
        const today = moment();
        const endContract = moment(date);
        return Math.ceil(endContract.diff(today, "days", true));
      },
      dateMoment(date) {
        if (date) {
          return moment(date)
            .locale(this.$i18n.t("lang"))
            .format("Do MMMM  YYYY");
        } else {
          return "No Date";
        }
      },
      getCompanyInfo() {
        let company_id = this.$store.state.company;
        const url = `${this.baseUrl}/v1/companies/${company_id}`;
        axios
          .get(url, {
            headers: {
              action: "Get Company Info",
              actionId: 4,
            },
          })
          .then((res) => {
            this.companyInfo = res.data.data;
            this.picEmail = res.data.data.email_pic;
          });
      },
      // getBillingInfo() {
      //   let company_id = this.$store.state.company;
      //   const url = `${this.baseUrl}/v3/billing/listbycompanyid?companyId=${company_id}`;
      //   axios
      //     .get(url, { headers: { action: "Get Billing Info", actionId: 4 } })
      //     .then((res) => {
      //       this.billingInfo = res.data.data[0];
      //     });
      // },
      checkCompanyType(type) {
        // Onboarded (biru)
        // End Trial (merah)
        // Trial (biru)
        // Stop Onboarded (merah)
        // Internal (biru)
        // Stop (merah)

        if (type === "Onboarded" || type === "Trial" || type === "Internal") {
          return true;
        } else {
          return false;
        }
      },
    },

    created() {
      this.getCompanies();
      this.getCompanyInfo();
      // this.getBillingInfo();
    },
    computed: {
      notSPV() {
        if (this.$store.state.role == 3) {
          return false;
        } else {
          return true;
        }
      },
      changePIC() {
        return this.$store.getters.getShowPICModal;
      },
      updatePlan() {
        return this.$store.getters.getshowChangePlanModal;
      },
      billingInfo() {
        return this.$store.getters.getBillingInfo
      }
    },
  };
</script>

<style>
  .data-company [class$="-disabled"],
  .data-company [class*="-disabled "] * {
    color: #000 !important;
  }

  .data-company .v-input__slot::before {
    border-style: none !important;
  }

  .id-company.v-text-field.v-input--is-disabled .v-input__slot::before {
    border-image: none !important;
    border-color: #c4c4c4;
  }
</style>

<style scoped>
  .flexer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #c4c4c4;
  }

  .allow-hover:hover {
    cursor: pointer;
  }

  .plus-icon {
    color: #c4c4c4;
    font-size: 40px;
  }
</style>